import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import { checkProductsLicenceState } from '../actions';
import { INITIALIZE_VIEW } from '../actions/initialize-view';
import { fetchPersonalizationSiteTraits } from '../actions/personalization-site-traits';
import { type ActionsObservable } from 'redux-observable';
import { merge } from 'rxjs/observable/merge';
import { isActivationMethodDetermined } from '../activation/selectors';
import { planConfluenceActivation } from '../actions/activate-confluence';
import { type Store } from 'redux';
import { type State } from '../types';

export default (action$: ActionsObservable<any>, store: Store<State>) =>
	action$.ofType(INITIALIZE_VIEW).switchMap(() => {
		const state = store.getState();
		const baseObservables = [checkProductsLicenceState(), fetchPersonalizationSiteTraits()];
		if (isActivationMethodDetermined(state)) {
			return merge(baseObservables);
		}
		return merge([...baseObservables, planConfluenceActivation()]);
	});
